module.exports = __webpack_public_path__ + "img/s_yellow_heart.426ff86f.png";